**Skewness** measures the degree of asymmetry in statistical return distribution,
through differentiating extreme values in one tail against the other tail.
Positive (negative) skewness implies that there are more extremely larger gains (losses).
